import { Page } from 'src/providers/tabs/tabs-meta';
import * as fp from 'lodash/fp';

export const PermissionEnum = Object.freeze({
  NotDefined: 'NotDefined',
  Statistics: 'Statistics',
  Dutyplan: 'Dutyplan',
  Timetracking: 'Timetracking',
  News: 'News',
  StatisticsAllUsers: 'StatisticsAllUsers',
  GeoPositioning: 'GeoPositioning',
  Options: 'Options',
  Allocation: 'Allocation',
  CalendarSync: 'CalendarSync',
  Newsreply: 'Newsreply',
  NewsRequest: 'NewsRequest',
  NewsViewSent: 'NewsViewSent',
  PresenceMonitoring: 'PresenceMonitoring',
  CheckPersonalNumber: 'CheckPersonalNumber',
  Enquiries: 'Enquiries',
  Bookingcodes: 'Bookingcodes',
  QRBooking: 'QRBooking',
  BookingQRScanning: 'BookingQRScanning',
  Pinboard: 'Pinboard',
});
interface PagePermissionMap {
  [key: string]: (actualPermissions: string[]) => boolean | undefined;
}
export const PagePermissionMap: PagePermissionMap = Object.freeze({
  [Page.SingleuserBooking]: all([PermissionEnum.Timetracking]),
  [Page.SingleuserDuties]: all([PermissionEnum.Dutyplan]),
  [Page.SingleuserStatistics]: all([PermissionEnum.Statistics]),
  [Page.SingleuserPinboard]: all([PermissionEnum.Pinboard]),
  [Page.SingleuserStatisticsAll]: all([PermissionEnum.StatisticsAllUsers]),
  [Page.SingleuserNews]: any([PermissionEnum.News, PermissionEnum.NewsViewSent]),
  [Page.SingleuserNewsDetails]: any([PermissionEnum.News, PermissionEnum.NewsViewSent]),
  [Page.SingleuserReply]: all([PermissionEnum.News, PermissionEnum.Newsreply]),
  [Page.SingleuserRequests]: all([PermissionEnum.NewsRequest]),
  [Page.SingleuserOptions]: all([PermissionEnum.Options]),
  [Page.SingleuserEnquiries]: all([PermissionEnum.Enquiries]),
  [Page.SingleuserMonitoring]: all([PermissionEnum.PresenceMonitoring]),
  [Page.SingleuserMore]: alwaysAllowed,

  [Page.MultiuserQRBooking]: all([PermissionEnum.QRBooking]),
  [Page.MultiuserBooking]: all([PermissionEnum.Timetracking]),
  [Page.MultiuserPinboard]: all([PermissionEnum.Pinboard]),
  [Page.MultiuserMonitoring]: all([PermissionEnum.PresenceMonitoring]),
  [Page.MultiuserMore]: alwaysAllowed,
});
function any(requiredPermissions: Array<string>) {
  return (actualPermissions: Array<string>): boolean => {
    if (!requiredPermissions) return true;
    if (!actualPermissions) return false;

    const matches = fp.intersection(requiredPermissions, actualPermissions);
    if (fp.isArray(matches)) {
      return !!fp.intersection(requiredPermissions, actualPermissions).length;
    }

    return false;
  };
}
function all(requiredPermissions: Array<string>) {
  return (actualPermissions: Array<string>): boolean => {
    if (!requiredPermissions) return true;
    if (!actualPermissions) return false;

    const matches = fp.intersection(requiredPermissions, actualPermissions);
    if (fp.isArray(matches)) {
      return (
        fp.intersection(requiredPermissions, actualPermissions).length ===
        requiredPermissions.length
      );
    }

    return false;
  };
}
function alwaysAllowed(requiredPermissions?: Array<string>) {
  return true;
}
function alwaysForbidden(requiredPermissions?: Array<string>) {
  return false;
}
